import { useEffect, useRef, useState } from 'react'
import type { DupPlace } from './masterView'

// [겹치는 전송코드 N] — 눌러 어떤 코드가 어느 인터페이스·항목에 겹치는지 본다. 자리를 누르면 그 인터페이스 항목 편집으로
// (항목 편집에서 겹치는 전송코드 칸은 노랗게). MES 는 전송코드로 값을 구분하므로 같은 코드가 둘 이상이면 하나만 남겨야 한다.
export default function DupCodes({ places, activeKey, align = 'left', onPick }: {
  places: [string, DupPlace[]][]
  activeKey?: string | null // 지금 보고 있는 인터페이스 (항목 편집)
  align?: 'left' | 'right' // 목록을 버튼 왼쪽 끝에 맞출지 오른쪽 끝에 맞출지
  onPick: (machineKey: string) => void
}) {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLSpanElement>(null)
  useEffect(() => {
    if (!open) return
    const onDown = (e: MouseEvent) => { if (!ref.current?.contains(e.target as Node)) setOpen(false) }
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false) }
    window.addEventListener('mousedown', onDown)
    window.addEventListener('keydown', onKey)
    return () => { window.removeEventListener('mousedown', onDown); window.removeEventListener('keydown', onKey) }
  }, [open])
  if (places.length === 0) return null

  return (
    <span ref={ref} className="relative">
      <button onClick={() => setOpen(o => !o)} title="어떤 전송코드가 어디에서 겹치는지 보기"
        className="text-amber-600 underline decoration-dotted underline-offset-2 hover:text-amber-700">겹치는 전송코드 {places.length}</button>
      {open && (
        <div className={`absolute ${align === 'right' ? 'right-0' : 'left-0'} top-full mt-1 z-50 w-80 max-h-96 overflow-y-auto bg-surface border border-gray-200 rounded-lg shadow-lg p-3 text-left`}>
          <p className="text-xs text-gray-500 mb-2">
            같은 전송코드가 두 항목 이상에 있습니다. MES 는 전송코드로 값을 구분하므로 하나만 남기고 나머지는 바꾸세요.
            항목 편집에서는 노랗게 표시됩니다.
          </p>
          <ul className="space-y-2">
            {places.map(([code, ps]) => (
              <li key={code}>
                <div className="font-mono text-xs text-gray-800">{code} <span className="text-gray-400 font-sans">· {ps.length}곳</span></div>
                <ul className="mt-0.5">
                  {ps.map(p => (
                    <li key={p.itemKey}>
                      <button onClick={() => { onPick(p.machineKey); setOpen(false) }}
                        className={`w-full flex items-center gap-2 px-2 py-1 rounded text-xs text-left hover:bg-gray-100 ${p.machineKey === activeKey ? 'bg-blue-50' : ''}`}>
                        <span className="font-mono text-gray-700 shrink-0">{p.machineCode || '(ID 없음)'}</span>
                        <span className="text-gray-500 truncate">{p.description || '설명 없음'}</span>
                        <span className="ml-auto text-accent shrink-0">{p.machineKey === activeKey ? '보는 중' : '열기'}</span>
                      </button>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </div>
      )}
    </span>
  )
}
